import { Navigate, Outlet, useLocation } from "react-router";

import { useSession } from "@/app/session/useSession";
import { Logo } from "@/shared/ui/Logo";

export function FullScreenLoader() {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas" aria-busy="true">
      <Logo className="animate-pulse" />
    </div>
  );
}

export function RequireSession() {
  const { state } = useSession();
  const location = useLocation();

  if (state.status === "loading") return <FullScreenLoader />;
  if (state.status === "signed-out") {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }
  return <Outlet />;
}
